import { useEffect } from "react";

declare global {
  interface Window {
    chatwootSDK: {
      run: (config: { websiteToken: string; baseUrl: string }) => void;
    };
  }
}

interface ChatwootScriptProps {
  pageURL: string;
}

const ChatwootScript = ({ pageURL }: ChatwootScriptProps) => {
  useEffect(() => {
    // Check if the current URL is the page where you want to hide the chat bubble
    if (window.location.href === pageURL) {
      // Do nothing or remove the Chatwoot script
    } else {
      // Add Chatwoot script
      const script = document.createElement("script");
      script.defer = true;
      script.async = true;
      script.src = "https://app.chatwoot.com/packs/js/sdk.js";
      document.head.appendChild(script);

      script.onload = function () {
        window.chatwootSDK.run({
          websiteToken: "jdzbwUjP27pArRmSNDkCBxVa",
          baseUrl: "https://app.chatwoot.com",
        });
      };
    }
  }, [pageURL]);

  return null;
};

export default ChatwootScript;
